module.exports = __webpack_public_path__ + "img/icon_map_red.2289bb21.svg";